// missing forEach on NodeList for IE11
if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}
// Mouse users
// https://www.w3.org/WAI/tutorials/menus/flyout/#mouse-users
const elems = document.querySelectorAll('.primary-nav__item, .site-footer__main-nav > .site-footer__nav-item');

elems.forEach(el => {
  el.addEventListener('mouseover', () => {
    el.classList.add('active');
  });

  el.addEventListener('mouseout', () => {
    // const activeNavItem = el.querySelector('.active');

    if (el.classList.contains('active')) {
      el.classList.remove('active');
    }
  });

  // Keyboard users
  // https://www.w3.org/WAI/tutorials/menus/flyout/#use-button-as-toggle
  const eventType = 'ontouchstart' in document.documentElement === true ? 'touchstart' : 'click';
  const childNavButton = el.querySelector('button');
  if (childNavButton) {
    childNavButton.addEventListener(eventType, evt => {
      if (evt.target.parentNode.classList.contains('active')) {
        evt.target.parentNode.classList.remove('active');
        evt.target.setAttribute('aria-expanded', 'false');
      } else {
        evt.target.parentNode.classList.add('active');
        evt.target.setAttribute('aria-expanded', 'true');
      }
    });
  }
});

const eventType =
  'ontouchstart' in document.documentElement === true ? 'touchstart' : 'click';
// Language switcher trigger
// Didn't use the same code as primary nav as trigger is not a link
const languageButton = document.querySelector(
  '[aria-controls="language-selector"]'
);

const languageMenu = document.querySelector('.language-dropdown');

if (languageButton && languageMenu) {
  let languageEventController = new AbortController();

  const closeLanguageMenu = () => {
    languageButton.setAttribute('aria-expanded', 'false');
    languageEventController.abort();
    languageEventController = new AbortController();
  };

  const openLanguageMenu = () => {
    languageButton.setAttribute('aria-expanded', 'true');
    document.addEventListener(
      'keydown',
      (evt) => {
        if (evt.key === 'Escape') {
          evt.stopPropagation();
          closeLanguageMenu();
        }
      },
      { signal: languageEventController.signal }
    );
  };

  const toggleLanguageMenu = () => {
    if (languageButton.getAttribute('aria-expanded') === 'true') {
      closeLanguageMenu();
    } else {
      openLanguageMenu();
    }
  };

  languageButton.addEventListener(eventType, toggleLanguageMenu, false);
  languageMenu.addEventListener('mouseover', openLanguageMenu, false);
  languageMenu.addEventListener('mouseleave', closeLanguageMenu, false);
  languageMenu.addEventListener('focusout', (e) => {
    if (languageMenu.contains(e.relatedTarget)) {
      return;
    }
    closeLanguageMenu();
  });
}


